export enum EEntityGroupType {
    Events = 'events',
    Categories = 'categories',
}

export enum EInputType {
    Text = 'text',
    TextArea = 'textArea',
    Color = 'color',
    Date = 'date',
    Time = 'time',
    Select = 'select',
}

export enum EResponseStatus {
    Success = 'success',
    Loading = 'loading',
    Error = 'error',
    Default = 'default',
}
